"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Sidebar/BroadcastListHeader/TeamPicker/Content.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _myRelations = require('shared/selectors/myRelations');
var _hooks = require('web/services/hooks');
var _keyboard = require('web/services/keyboard');






const TeamPickerContent = ({ onSelectTeam }) => {
  const teamGroups = _hooks.useAppSelector.call(void 0, _myRelations.selectMyPhoneTeamGroupsList)

  return (
  _react2.default.createElement('div', { className: "broadcast--list-header--team-picker", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
    , _react2.default.createElement('div', { className: "broadcast--list-header--team-picker-group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
      , _react2.default.createElement('span', {
        role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
        className: "broadcast--list-header--team-picker-option",
        onClick: () => onSelectTeam(null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
, "All Campaigns"

      )
    )
    ,  teamGroups.map(g => (
      _react2.default.createElement('div', { key: g.orgKey, className: "broadcast--list-header--team-picker-group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
        , _react2.default.createElement('h5', { className: "broadcast--list-header--team-picker-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
          ,  g.orgName 
        )
        ,  g.teamsList.map(t => (
          _react2.default.createElement('span', {
            key: t.TeamKey,
            role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
            className: "broadcast--list-header--team-picker-option",
            onClick: () => onSelectTeam(t.TeamKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}

            ,  t.Name 
          )
        ))
      )
    ))
  )
  )
}

exports. default = _react.memo.call(void 0, TeamPickerContent)
